import React, { useEffect, useState } from "react";
import axios from "axios";
import { ShieldCheck } from "lucide-react";
import { useApp } from "../../context";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Persistent, reassuring banner shown to a USER while a support agent is
// actively viewing their account (via the "Allow support to view my account"
// flow). Polls the user-facing /support/my-active endpoint.
const SupportViewingBanner = () => {
  const { user } = useApp();
  const [session, setSession] = useState(null);

  useEffect(() => {
    if (!user) { setSession(null); return; }
    let alive = true;
    const check = async () => {
      try {
        const { data } = await axios.get(`${API}/support/my-active`, { timeout: 10000 });
        if (alive) setSession(data?.active ? data : null);
      } catch { if (alive) setSession(null); }
    };
    check();
    const id = setInterval(check, 20000);
    return () => { alive = false; clearInterval(id); };
  }, [user]);

  if (!session) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[2147483600] flex items-center justify-center gap-2 px-4 py-2 text-center bg-gradient-to-r from-amber-500 to-orange-500 text-black font-bold text-xs sm:text-sm shadow-lg"
      style={{ paddingTop: "max(0.5rem, env(safe-area-inset-top))" }}
      data-testid="support-viewing-banner"
      role="status"
    >
      <ShieldCheck size={16} className="flex-shrink-0" />
      <span>{session.admin_name || "An adult from support"} is viewing your account to help you right now.</span>
    </div>
  );
};

export default SupportViewingBanner;
